export default __webpack_public_path__ + "static/media/users.3da93741.png";